"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _decorators = require("../utils/propTypes/decorators");

var _UIModalDialog = _interopRequireDefault(require("./UIModalDialog"));

var _UIModalPanel = _interopRequireDefault(require("./UIModalPanel"));

var _ModalTransition = _interopRequireDefault(require("./internal/ModalTransition"));

var _getTransitionProps = _interopRequireDefault(require("./internal/getTransitionProps"));

var _EventRelay = require("../core/EventRelay");

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _DialogConstants = require("./DialogConstants");

var _AbstractModal = _interopRequireDefault(require("./internal/AbstractModal"));

var UIModal =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIModal, _PureComponent);

  function UIModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIModal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIModal).call(this, props));
    _this._closeStartRelay = (0, _EventRelay.makeEventRelay)();
    _this._openCompleteRelay = (0, _EventRelay.makeEventRelay)();
    _this._getTransitionProps = (0, _memoizeOne.default)(_getTransitionProps.default);
    return _this;
  }

  (0, _createClass2.default)(UIModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          use = _this$props.use,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["use"]);

      if (use === 'sidebar') {
        return _react.default.createElement(_UIModalPanel.default, rest);
      }

      return _react.default.createElement(_AbstractModal.default, (0, _extends2.default)({}, this.props, {
        componentName: "UIModal",
        Transition: _ModalTransition.default
      }));
    }
  }]);
  return UIModal;
}(_react.PureComponent);

UIModal.propTypes = (0, _extends2.default)({}, _UIModalDialog.default.propTypes, {
  ModalDialog: (0, _decorators.hidden)(_react.PropTypes.func),
  onCloseComplete: _react.PropTypes.func,
  onCloseStart: _react.PropTypes.func,
  onOpenComplete: _react.PropTypes.func,
  onOpenStart: _react.PropTypes.func,
  use: _react.PropTypes.oneOf(Object.keys(_DialogConstants.MODAL_USE_CLASSES)).isRequired,
  _contextual: _react.PropTypes.bool
});
UIModal.defaultProps = (0, _extends2.default)({}, _UIModalDialog.default.defaultProps, {
  ModalDialog: _UIModalDialog.default,
  _contextual: false
});
UIModal.displayName = 'UIModal';
var _default = UIModal;
exports.default = _default;
module.exports = exports.default;